export const COMMAND_TYPE = {
  PING: 0,
  HISTORY_REQUEST: 1,
  MESSAGE: 2,
  MESSAGE_READ: 3,
  SLOT_OFFER: 4,
  PACKAGE_OFFER: 5,
};

export const REPLY_TYPE = {
  PONG: 0,
  HISTORY: 1,
};

export const EVENT_TYPE = {
  HELLO: 0,
  MESSAGE: 1,
  MESSAGE_READ: 2,
  USER_STATUS_CHANGE: 3,
};

export const USER_STATUS = {
  ONLINE: 0,
  OFFLINE: 1,
};

// Типы сообщений (поле type в Message).
// Карточки-сущности приходят с готовым UI-контрактом в поле card.
export const MESSAGE_TYPE = {
  TEXT: 'text',
  SLOT_OFFER: 'slot_offer',
  APPOINTMENT_CARD: 'appointment_card',
  PACKAGE_CARD: 'package_card',
  PACKAGE_OFFER_CARD: 'package_offer_card',
};

// Типы оптимистичных сообщений, которые фронт ставит при отправке
// (сервер подтвердит сообщением с карточным типом, см. SENT_TO_CARD_TYPE)
export const PENDING_MESSAGE_TYPE = {
  SLOT_OFFER: 'slot_offer',
  PACKAGE_OFFER: 'package_offer',
};

// Соответствие: отправленный тип -> тип карточки от сервера
export const SENT_TO_CARD_TYPE = {
  [PENDING_MESSAGE_TYPE.PACKAGE_OFFER]: MESSAGE_TYPE.PACKAGE_OFFER_CARD,
};

let commandId = 0;

export const getNextCommandId = () => {
  commandId += 1;
  return commandId;
};

export const resetCommandId = () => {
  commandId = 0;
};
